import { createReducer } from '@reduxjs/toolkit'
import { getTenantOrganizationSuccess } from '../actions/tenantService'

const initialState = {}

export const organization = createReducer(initialState, {
  [getTenantOrganizationSuccess.type]: (state, action) => action.payload,
})
